<span class="float-end">
    <a [routerLink]="['create']" class="btn btn-primary" i18n>Create</a>
</span>
<h3 class="mt-3" i18n>Search results</h3>

<div class="table-responsive-lg">
    <table class="table table-hover">
        <thead>
            <tr>
                <th i18n>Name</th>
                <th i18n>Type</th>
                <th i18n>Email</th>
                <th i18n>Mobile phone</th>
                <th class="d-print-none"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let user of adsUsers">
                
                <td class="align-middle"><a [routerLink]="user.id.toString()">{{ user.first_name }} {{ user.last_name}}</a></td>
                <td class="align-middle">{{ user.type | i18nSelect: userTypes }}</td>
                <td class="align-middle"><a href="mailto:{{ user.email }}">{{ user.email }}</a></td>
                <td class="align-middle"><a href="tel:{{ user.mobile_phone }}">{{ user.mobile_phone }}</a></td>
                <td class="align-middle text-end d-print-none">
                    <a [routerLink]="user.id.toString()" class="btn btn-primary btn-sm" i18n>Edit</a>
                </td>
            </tr>
        </tbody>
        <tfoot>
            <tr>
                <th colspan="8"><span i18n>Found</span> {{ adsUsers.length }}</th>
            </tr>
        </tfoot>
    </table>
</div>